import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { PAGE_FOOTER_MODEL } from '../../../model/PAGE_FOOTER_MODEL';



@IonicPage()
@Component({
  selector: 'botton-menu-component',
  templateUrl: 'botton-menu-component.html',
})
export class BottonMenuComponent {

  public footerPages: PAGE_FOOTER_MODEL[];

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    console.log("footer loaded")
    this.footerPages = this.inicializaPaginas();
  }


  private inicializaPaginas(): PAGE_FOOTER_MODEL[] {
    return [
      {
        name: "Mapa",
        icon: "custom-map",
        pageComponent: "HomePage"
      },
      {
        name: "Rank",
        icon: "custom-rank",
        pageComponent: "RankPage"
      },
      {
        name: "Ocorrência",
        icon: "custom-occurrences",
        pageComponent: "OccurrencesPage"
      },
      {
        name: "Perfil",
        icon: "custom-perfil",
        pageComponent: "PerfilPage"
      }
    ]
  }

  public carregaPagina(pageComponent: string) {
    // verifica se ja não estamos na pagina
    if (this.navCtrl.getActive().id != pageComponent) {
      this.navCtrl.setRoot(pageComponent).catch((err) => { console.error(err) })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/botton-menu-component/botton-menu-component.ts